export { default as HomeHero } from './HomeHero/HomeHero';
export { default as HomeHitos } from './HomeHitos/HomeHitos';
export { default as Universe99 } from './Universe99/Universe99';
export { default as HomeLeadingCompanies } from './HomeLeadingCompanies/HomeLeadingCompanies';
export { default as HomePartners } from './HomePartners/HomePartners';
export { default as HomeTechnologyExperience } from './HomeTechnologyExperience/HomeTechnologyExperience';
export { default as HomeCO2 } from './HomeCO2/HomeCO2';
export { default as HomeMediaPresence } from './HomeMediaPresence/HomeMediaPresence';
